/* eslint-disable */
import { SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { disableFunctions, filterActions } from "./filters";

export const countryPositions = {
  nl: {
    lat: 52.0642372,
    lng: 5.2958198
  },
  de: {
    lat: 51.2926608,
    lng: 10.12673
  },
  en: {
    lat: 53.0359783,
    lng: -2.2616411
  },
  lt: {
    lat: 55.1918651,
    lng: 23.2958457
  },
  active: {}
}

// Bereken het verschoven middelpunt op basis van de pixeloffset
export function centerMap(location = null, zoom = Math.min(gm.map.getZoom(), gm.maxZoom)) {
  const mapCenter = location || gm.map.getCenter();

  // Alleen op desktop
  if (screen.width >= 992) {
    let pixelOffsetX = 0;
    let pixelOffsetY = 0;

    const resultsWrapper = document.querySelector('.js-dealers-results-wrapper');
    if (resultsWrapper) {
      const resultsWrapperWidth = resultsWrapper.clientWidth;

      if (screen.width >= 1550) {
        pixelOffsetX = resultsWrapperWidth * 0.65;
      } else {
        pixelOffsetX = resultsWrapperWidth * 0.5;
      }
    }

    gm.map.setCenter(mapCenter);
    gm.map.setZoom(zoom);

    const projection = gm.map.getProjection();
    if (projection) {
      const point1 = projection.fromLatLngToPoint(mapCenter);
      const point2 = new google.maps.Point(
        ((typeof pixelOffsetX === 'number' ? pixelOffsetX : 0) / Math.pow(2, gm.map.getZoom())) || 0,
        ((typeof pixelOffsetY === 'number' ? pixelOffsetY : 0) / Math.pow(2, gm.map.getZoom())) || 0
      );

      gm.map.panTo(projection.fromPointToLatLng(new google.maps.Point(
        point1.x - point2.x,
        point1.y + point2.y
      )));
    }
  }
}

export function centerMarker(marker) {
  let pixelOffsetX = 0;
  let pixelOffsetY = 0;

  const resultsWrapperWidth = document.querySelector('.js-dealers-results-wrapper').clientWidth;

  if (screen.width >= 992) {
    pixelOffsetX = resultsWrapperWidth * 0.5;
  }
  if (screen.width >= 1550) {
    pixelOffsetX = resultsWrapperWidth * 0.65;
  }

  gm.map.setZoom(Math.min(gm.map.getZoom(), gm.maxZoom));

  var point1 = gm.map.getProjection().fromLatLngToPoint(marker.getPosition());
  var point2 = new google.maps.Point(
    ((typeof (pixelOffsetX) == 'number' ? pixelOffsetX : 0) / Math.pow(2, gm.map.getZoom())) || 0,
    ((typeof (pixelOffsetY) == 'number' ? pixelOffsetY : 0) / Math.pow(2, gm.map.getZoom())) || 0
  );

  gm.map.panTo(gm.map.getProjection().fromPointToLatLng(new google.maps.Point(
    point1.x - point2.x,
    point1.y + point2.y
  )));
}

export function initMap() {
  if (gm.googleMapsEl) {
    gm.defaultBounds = new google.maps.LatLngBounds();
    gm.geocoder = new google.maps.Geocoder();

    const language = document.documentElement.lang;
    let centerPosition;
    switch (language) {
      case 'nl':
        centerPosition = countryPositions.nl;
        break;
      case 'de':
        centerPosition = countryPositions.de;
        break;
      case 'en':
        centerPosition = countryPositions.en;
        break;
      case 'lt':
        centerPosition = countryPositions.lt;
        break;
    }
    countryPositions.active = centerPosition;
    gm.latlngCenter = new google.maps.LatLng(centerPosition.lat, centerPosition.lng);

    gm.createMap();
    gm.createMarkers();
    gm.clusterMarkers();

    // Show content
    gm.googleMapsWrapperEl.forEach((el) => {
      el.style.display = 'block';
    });
    gm.googleMapsCookieBannerEl.forEach((el) => {
      el.style.display = 'none';
    });

    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({
        name: 'geolocation'
      }).then((result) => {
        disableFunctions();
        if (result.state !== 'denied') {
          document.querySelector('.js-location').style.visibility = "visible";
          filterActions.myLocation();
        } else {
          filterActions.showAll();
        }
      }).catch(error => {
        console.error(error);
      });
    } else {
      disableFunctions();
      filterActions.showAll();
    }
  }
}

export const gm = {
  dataItems: document.querySelectorAll('.js-data .js-data-item'),
  googleMapsEl: document.querySelector('.js-google-maps'),
  googleMapsWrapperEl: document.querySelectorAll('.js-google-maps-wrapper'),
  googleMapsCookieBannerEl: document.querySelectorAll('.js-google-maps-cookie'),
  maxZoom: window.width >= 992 ? 11 : 15,
  map: null,
  geocoder: null,
  locations: [],
  activeWindow: null,
  defaultBounds: null,
  cityBounds: null,
  latlngCenter: null,
  allMarkers: null,
  markerCluster: null,
  listener: null,
  createMap: () => {
    // Default map, mapId editable
    gm.map = new google.maps.Map(gm.googleMapsEl, {
      zoom: window.width >= 992 ? 7 : 9,
      center: gm.latlngCenter,
      mapId: '3b4ffd3a84f5cdef',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      clickableIcons: false
    });
  },
  createMarkers: () => {
    // Get all possible markers
    if (gm.dataItems) {
      gm.dataItems.forEach((item) => {
        const marker = item.querySelector('.js-marker');
        const markerData = {
          lat: parseFloat(marker.dataset.lat),
          lng: parseFloat(marker.dataset.lng),
          content: marker.innerHTML,
          id: item.dataset.id,
          premium: item.dataset.premium,
          title: item.dataset.title
        };

        gm.locations.push(markerData);
      });

      // Add some markers to the map with some events
      gm.allMarkers = gm.locations.map((loc, i) => {
        const marker = new google.maps.Marker({
          position: {
            lat: loc.lat,
            lng: loc.lng
          },
          icon: {
            url: '/wp-content/themes/vivafloors/dist/assets/images/vivafloors-markers.svg',
          },
          id: loc.id,
          premium: loc.premium,
          title: loc.title
        });

        gm.defaultBounds.extend(loc);

        const infoWindow = new google.maps.InfoWindow({
          content: loc.content,
        });

        // open info window when marker is clicked
        marker.addListener('click', () => {
          if (gm.activeWindow !== null) {
            gm.activeWindow.close();
          }
          centerMarker(marker);
          const listener = google.maps.event.addListenerOnce(gm.map, 'idle', function () {
            listener.remove();

            // send user location
            if (typeof gtag === 'function') {
              gtag('event', 'dealer', {
                'marker_click': marker.title
              });
            }

            infoWindow.open(gm.map, marker);
            gm.activeWindow = infoWindow;
          });

        });

        gm.map.addListener('click', () => {
          infoWindow.close();
        });

        return marker;
      });
    }
  },
  clusterMarkers: () => {
    const renderer = {
      render: function ({ count, position }) {
        return new google.maps.Marker({
          label: { text: count.toString(), color: 'white', fontSize: '12px' },
          position,
          icon: {
            url: '/wp-content/themes/vivafloors/dist/assets/images/vivafloors-markers-cluster.svg',
          },
          title: 'Cluster',
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
      }
    };

    const algorithm = new SuperClusterAlgorithm({
      maxZoom: gm.maxZoom - 1
    });

    // Custer all the things
    gm.markerCluster = new MarkerClusterer({
      map: gm.map,
      algorithm: algorithm,
      renderer: renderer,
      onClusterClick: (event, cluster, map) => {
        map.fitBounds(cluster.bounds);
        const listener = google.maps.event.addListenerOnce(gm.map, 'idle', function () {
          listener.remove();
          centerMap();
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!gm.dataItems || gm.dataItems.length === 0) {
    gm.dataItems = document.querySelectorAll('.js-data .js-data-item');
  }

  if (!gm.googleMapsEl) {
    gm.googleMapsEl = document.querySelector('.js-google-maps');
  }

  if (!gm.googleMapsWrapperEl || gm.googleMapsWrapperEl.length === 0) {
    gm.googleMapsWrapperEl = document.querySelectorAll('.js-google-maps-wrapper');
  }

  if (!gm.googleMapsCookieBannerEl || gm.googleMapsCookieBannerEl.length === 0) {
    gm.googleMapsCookieBannerEl = document.querySelectorAll('.js-google-maps-cookie');
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/dealers/map.js